import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { getFilteredData, getCategoryItemsSubset } from "./selectors/data"
import { getOnly, getDisabled, getFocusedChartLine } from "./selectors"
import { getOptions, getSelectedOption } from "./selectors/options"
import { getDrift } from "./selectors/drift"
import { getFactorCategoryId, getAvailableSelectViewFactors, getScaleIds, getShowSegment, getAllCategoryItems } from "./selectors/items"
import { getFileName } from "./selectors/file"
import { getDatesAdjusted, getFetchStartDate } from "./selectors/dates"
import { getFirstRiskDate, getLastRiskDate, getRiskSelectedDate, getRisk, getAttributionMethod, getMCTEAdjustedSegment, getMCTEAdjustedBase } from "./selectors/risk"
import { VIEW_TYPES } from "helpers/base"
import { convertPositionSetType } from "helpers/compositeSecurities"
import { getCurrency } from "modules/analyze-composite-security/selectors"

export default createModule({
  view,
  // These values get adjusted when viewing a segment and active so we cannot simply use the props
  externalProps: (state, props) => ({
    attributionMethod: getAttributionMethod(state, props),
    segment: getMCTEAdjustedSegment(state, props),
    base: getMCTEAdjustedBase(state, props),
  }),
  required: ["account", "modelId", "positionSetId", "positionSetType"],
  data: [{
    resource: "analyzeCompositeRisk",
    as: null,
    url: ({ modelId, positionSetId, positionSetType, startDate, base, driftDates, baseSignature, baseStartDate, viewType, segment, expand, currency, attributionMethod }) => {
      const from = startDate < driftDates.startDate ? startDate : driftDates.startDate
      const to = driftDates.endDate

      const fetchStartDate = viewType === VIEW_TYPES.ACTIVE && baseStartDate && from < baseStartDate ? baseStartDate : from

      return {
        id: `analyzeCompositeRisk-${modelId}${positionSetId}${positionSetType}${fetchStartDate}${to}${viewType}${baseSignature}${JSON.stringify(segment)}${expand}${currency}${attributionMethod}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $from: Date!, $to: Date!, $base: [PositionSetInput]) {
          model (id: $modelId) {
            simulation (positionSet: $positionSet, from: $from, to: $to, base: $base, interval: AUTO) {
              risk {
                date
                total
                attribution {
                  summary {
                    factors
                    specific
                  }
                  factors {
                    id
                    category
                    name
                    value
                  }
                }
              },
            }
          }
        }`,
        variables: {
          modelId,
          positionSet: {
            type: convertPositionSetType(positionSetType),
            id: positionSetId,
            segment,
            expand,
          },
          from: fetchStartDate,
          to,
          base: viewType === VIEW_TYPES.ACTIVE ? [base] : undefined,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    data: getFilteredData(state, props),
    items: getCategoryItemsSubset(state, props),
    risk: getRisk(state, props),
    drift: getDrift(state, props),
    firstDate: getFirstRiskDate(state, props),
    selectedDate: getRiskSelectedDate(state, props),
    fetchStartDate: getFetchStartDate(state, props),
    lastRiskDate: getLastRiskDate(state, props),
    options: getOptions(state, props),
    fileName: getFileName(state, props),
    selectedOption: getSelectedOption(state, props),
    factorCategoryId: getFactorCategoryId(state, props),
    allCategoryItems: getAllCategoryItems(state, props),
    disabled: getDisabled(state, props),
    only: getOnly(state),
    datesAdjusted: getDatesAdjusted(state, props),
    availableSelectViewFactors: getAvailableSelectViewFactors(state, props),
    yScaleIds: getScaleIds(),
    showSegment: getShowSegment(state, props),
    focusedChartLine: getFocusedChartLine(state),
    currency: getCurrency(state),
  }),
  actions: {
    ...Creators,
    addNotification: notificationsCreators.add,
    openDialog: DialogCreators.open,
  },
})
